import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import {
    StyledSectionTitle,
    StyledTitle,
    StyledSubtitle,
    StyledDesc,
} from "./style";

const SectionTitle = ({
    title,
    subtitle,
    description,
    layout,
    className,
    descProps,
    titleStyle,
    subtitleStyle,
    ...props
}) => {
    if (layout === 1) {
        return (
            <StyledSectionTitle
                className={cn(className, "section-title")}
                $layout={layout}
                {...props}
            >
                {subtitle && (
                    <StyledSubtitle style={subtitleStyle} $layout={layout}>
                        {subtitle}
                    </StyledSubtitle>
                )}
                {title && (
                    <StyledTitle
                        style={titleStyle}
                        $layout={layout}
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                )}
                {description && (
                    <StyledDesc {...descProps}>{description}</StyledDesc>
                )}
            </StyledSectionTitle>
        );
    }
    return (
        <StyledSectionTitle
            className={cn(className, "section-title")}
            $layout={layout}
            {...props}
        >
            {title && (
                <StyledTitle
                    $layout={layout}
                    dangerouslySetInnerHTML={{ __html: title }}
                />
            )}
            {subtitle && (
                <StyledSubtitle $layout={layout}>{subtitle}</StyledSubtitle>
            )}
            {description && (
                <StyledDesc {...descProps}>{description}</StyledDesc>
            )}
        </StyledSectionTitle>
    );
};

SectionTitle.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    layout: PropTypes.number,
    className: PropTypes.string,
    descProps: PropTypes.shape({}),
    titleStyle: PropTypes.shape({}),
    subtitleStyle: PropTypes.shape({}),
};

SectionTitle.defaultProps = {
    layout: 1,
    textAlign: "center",
    titleStyle: {},
    subtitleStyle: {},
};
export default SectionTitle;
